import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReceiptAlertPageRoutingModule } from './receipt-alert-routing.module';

import { ReceiptAlertDialog } from './receipt-alert.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReceiptAlertPageRoutingModule
  ],
  declarations: [ReceiptAlertDialog]
})
export class ReceiptAlertPageModule {}
